import * as React from "react"
import { Link } from "gatsby"
import logo from "../images/97auto_logo_header.jpg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'

const Footer = () => (
  <footer>   
    <div className="footer-wrapper">
      <div className="footer-section">
          
          <span className="contact">Get in touch</span>
          <span>443-688-6721</span><br />
          <span>info@97automotive.com</span>
          <span className="contact">Stay in touch</span>
          <span>
              <a href="https://www.facebook.com/97Auto/" className="social" rel="noreferrer noopener" target="_blank">
                <FontAwesomeIcon icon={faFacebook} /></a>   
                <a href="https://www.instagram.com/97_automotive/" className="social" rel="noreferrer noopener" target="_blank">
                <FontAwesomeIcon icon={faInstagram} /></a>                
            </span>   
        </div>
        <div className="footer-section">
          <Link to="/"><img src={logo} alt="97 Automotive MD logo" /></Link><br />
          <span>8328 Veterans Hwy, Ste J<br />
          Millersville, Maryland</span>  
        </div>   
        <div className="footer-section links">
        <span className="contact">Learn More</span>
          <Link to="/repairs">Repairs</Link><br />
          <Link to="/performance">Performance</Link><br />
          <Link to="/maintenance">Maintenance</Link><br />
          <Link to="/about">About</Link><br />
          <Link to="/contact">Contact</Link><br />
          
        </div>            
    </div>    
      
    <div className="nav-footer-end text-center">
      <div>        
        <span>© {new Date().getFullYear()} 97 Automotive</span> <br /> 
            
      </div>      
    </div>     
  </footer>
)

export default Footer
